export const getFeeds = (state) => state.feeds
export const getFeedsCount = (state) => state.feedsCount
export const getComments = (state) => state.comments
export const getReactions = (state) => state.reactions
